import cx from 'classnames'

import Styles from './EnableCookies.module.scss'
import Shared from '../../Shared.module.scss'
import LoginStyles from '../../LoginOrSignup.module.scss'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import ImageAssembly from '../Blaze/Testimonials/CartoonTestimonials/ImageAssembly'
import { Text } from 'blaze-ui/Text/Text'
import { ArrowRight } from 'blaze-ui/icons'
import { Heading } from 'blaze-ui/Heading/Heading'
import blazeHeroText from '../../components/OnboardingLoader/blazeHeroText.png'
import CompanyLogo from 'components/CompanyLogo/CompanyLogo'

const EnableCookies = () => {
  const { isTabletPortrait, isMobile } = useResponsiveDesign()

  return (
    <div className={LoginStyles.wrapper} data-theme="light">
      <img src={blazeHeroText} style={{ display: 'none' }} alt="Preloaded Hero" />
      <div className={LoginStyles.content}>
        <div className={LoginStyles.companyLogo}>
          <CompanyLogo red small={isMobile || isTabletPortrait} />
        </div>
        <div className={cx(Shared.content, Styles.content)}>
          <div className={cx(Shared.leftPanel, Styles.leftPanel)}>
            <div className={cx(Shared.leftContent, Styles.leftContent)}>
              <div className={Styles.title}>
                <Heading level={1}>🍪</Heading>
                <Heading level={isMobile ? 2 : 1}>Please allow cookies from Blaze to continue</Heading>
              </div>
              <div className={Styles.subheaderContainer}>Blaze uses cookies for security and other purposes.</div>
              <div className={Styles.howToEnableCookies}>
                <Text variant="primary">How to do it</Text>
                <div className={Styles.steps}>
                  <Text variant="primary">1. Open Settings</Text>
                  <Text variant="primary">2. Click on "Advanced" tab</Text>
                  <Text variant="primary">3. Under "Privacy", un-check "Block all cookies"</Text>
                  <Text variant="primary">4. Refresh this page</Text>
                </div>
              </div>
            </div>
            <div className={Styles.footer}>
              <div className={Styles.termsOfServiceAndPrivacyPolicy}>
                <span>
                  <Text variant="label">By signing up, you agree to the</Text>
                  <br />
                  <a
                    tabIndex={0}
                    href={`https://get.blaze.ai/terms`}
                    target="_blank"
                    rel="noreferrer"
                    className={Shared.smallLink}
                  >
                    Terms of Service
                    <ArrowRight size={14} />
                  </a>{' '}
                  <Text variant="label">and</Text>{' '}
                  <a
                    href={`https://get.blaze.ai'/privacy-policy`}
                    target="_blank"
                    rel="noreferrer"
                    className={Shared.smallLink}
                  >
                    Privacy Policy
                    <ArrowRight size={14} />
                  </a>{' '}
                </span>
              </div>
            </div>
          </div>
          {!isTabletPortrait && !isMobile && (
            <ImageAssembly offsetTop={200} page={'continueWithEmailOrGmail'} useSmallerBubble />
          )}
        </div>
      </div>
    </div>
  )
}

export default EnableCookies
